import request from "@/service";

/* STS */
export function getSTS() {
  return request({
    url: `/sys/sts/token`,
    method: "get"
  });
}
